import { ResourceTargetTypeController } from './resource-target-type.controller';

export const ResourceTargetTypeComponent = {
  bindings: {
    targeting: '<',
  },
  template: `<i class="{{ $ctrl.icon }}"></i>`,
  controller: ResourceTargetTypeController,
};
